import { Component } from 'utils';
import { projectsActions } from '../../../store/reducers/projectsReducer';
import { projectActions } from "../../../store/reducers/projectReducer";
import _ from "lodash"

const ViewProjectsMode = "ViewProjectsMode"

@Component({
    controllerAs: 'vm',
    template: require('./projects.tpl.html')
})
export class ProjectsComponent {
    static $inject = ['$scope', '$state', 'store', 'favoriteProjectsService', 'sessionService', 'dbTypeService', '$timeout', 'projectsLocalHistoryService', 'utils'];
    constructor($scope, $state, store, favoriteProjectsService, sessionService, dbTypeService, $timeout, projectsLocalHistoryService, utils) {
        this.$scope = $scope;
        this.$state = $state;
        this.store = store;
        this.ViewMode = { Grid: 0, List: 1 };
        this.favoriteProjectsService = favoriteProjectsService;
        this.projectsLocalHistoryService = projectsLocalHistoryService;
        this.sessionService = sessionService;
        this.utils = utils;
        this.dbTypeService = dbTypeService;
        this.currentUserId = this.$state.$current.locals.globals.userDetails.data.id;
        this.$timeout = $timeout;
        this.store.dispatch({ type: projectsActions.GET_PROJECTS_WITH_DEPLOY_STATUS })
            .then(() => { this.loadedDeployedItems = true; });
        this.$scope.$watchCollection(() => this.store.getState().projects.projectWithDeployItems, (newCollection) => {
            if (newCollection == null)
                return;
            if (this.loadedDeployedItems) {
                if (newCollection.length == 0) {
                    this.projectsLocalHistoryService.ClearProjectHistory(this.currentUserId);
                }
                this.setProjects();
            }
        });

        this.$scope.$watch(() => this.selectedUserFilterKey, (newVal, oldVal) => {
            if (newVal == null)
                return;
            this.sessionService.set("selectedProjectFilter", newVal);
            this.selectedUserFilterText = this.createdUserFilters[newVal];
        });

        this.createdUserFilters = {
            "0": "All Projects",
            "1": "My Projects"
        };
        this.selectedUserFilterKey = "1";
        const selectedFilter = this.sessionService.get("selectedProjectFilter");
        if (selectedFilter)
            this.selectedUserFilterKey = selectedFilter;
        $timeout(() => {
            this.databaseTypes = (this.store.getState().enums && this.store.getState().enums.DBTypes) ? this.store.getState().enums.DBTypes : null;
            this.selectedDatabaseTypes = null;
        }, 0);
        this.currentViewMode = this.sessionService.get(ViewProjectsMode) || this.ViewMode.Grid;
    }

    projectsFilter(selectedUserFilter) {
        switch (selectedUserFilter) {
            case "1":
                return (item) => {
                    return item.createdById === this.currentUserId;
                };
            default:
                return function (item) {
                    return true;
                };
        }
    }

    openProject(project) {
        if (project.isDraft) {
            this.store.dispatch({
                type: projectActions.GET_EDIT_PROJECT,
                payload: { projectId: project.id },
                callback: (response) => {
                    this.store.dispatch({
                        type: projectActions.SET_EDIT_MODE,
                        payload: {
                            editMode: true,
                            isNew: (!response.data.parentId) ? true : false,
                            isNewDraft: response.data.isNew
                        }
                    });
                    this.sessionService.set(`project_${response.data.id}`, project.name + ' (Draft)');
                    this.$state.go('app.authorized.environments', {
                        id: response.data.id,
                        name: project.name + ' (Draft)'
                    })
                }
            });
        } else {
            this.sessionService.set(`project_${project.id}`, project.name);
            this.$state.go('app.authorized.environments', { id: project.id });
        }
    }

    getProjects() {
        if (this.m_projects == null)
            this.m_projects = [];
        return this.m_projects;
    }

    setProjects = () => {
        let mergeDictionary = {};
        let list = this.store.getState().projects.projectWithDeployItems.filter(m => m.name.toLowerCase().includes((this.filter && this.filter.toLowerCase()) || ''));
        if (this.selectedDatabaseTypes)
            list = list.filter(m => this.selectedDatabaseTypes.some(t => t.key === m.dbTypeId));
        let equalityPropName = "id";

        for (let i = 0; i < list.length; i++) {
            mergeDictionary[list[i][equalityPropName]] = list[i];
        }

        let keys = Object.getOwnPropertyNames(mergeDictionary);
        this.m_projects = [];
        for (let i = 0; i < keys.length; i++) {
            this.m_projects.push(mergeDictionary[keys[i]]);
        }

        this.m_projects.forEach((item, index, items) => {
            item.modifiedName = item.name + (item.isDraft ? " (Draft)" : "");
            item.isFavorite = this.favoriteProjectsService.IsFavorite(item.id);
            item.dbTypeImage = this.dbTypeService.getDbTypeImageFromLocalStorage(item.dbTypeId);
            if (!item.dbTypeImage) {
                this.dbTypeService.prepareDbTypesImages(this.store.getState().enums.DBTypes).then(
                    () => {
                        this.$timeout(() => {
                            item.dbTypeImage = this.dbTypeService.getDbTypeImageFromLocalStorage(item.dbTypeId);
                        }, 10);
                    }
                );
            }
        });

        this.m_projects.sort((firstEnv, secondEnv) => {
            if (firstEnv.isDraft && secondEnv.isDraft == false) {
                return 1;
            } else if (firstEnv.isDraft == false && secondEnv.isDraft) {
                return -1;
            }

            if (firstEnv.lastActivity != null && secondEnv.lastActivity != null) {
                let firstDate = new Date(firstEnv.lastActivity);
                let secondDate = new Date(secondEnv.lastActivity);
                if (firstDate.getTime() > secondDate.getTime()) {
                    return -1;
                } else if (firstDate.getTime() < secondDate.getTime()) {
                    return 1;
                } else {
                    return 0;
                }
            }

            if (firstEnv.lastActivity != null && secondEnv.lastActivity == null) {
                return -1;
            }
            if (firstEnv.lastActivity == null && secondEnv.lastActivity != null) {
                return 1;
            }

            return firstEnv.name.localeCompare(secondEnv.name);
        });
    }

    toggleFavorite(project) {
        this.favoriteProjectsService.ToggleFavoriteProject(project.id);
        project.isFavorite = this.favoriteProjectsService.IsFavorite(project.id)
    }

    addProject() {
        this.store.dispatch({ type: projectActions.GET_NEW_PROJECT, payload: { projectType: 1 } })
            .then(() => this.$state.go('app.authorized.projectWizard.settings', { id: 0, isNew: true }));
    }

    setDatabaseType(type) {
        if (type >= 0 && this.databaseTypes) {
            return this.databaseTypes.find(m => m.key == type).value.replace("-", "").toLowerCase();
        }
        return "orcale"
    }

    changeViewMode = (mode) => {
        this.currentViewMode = mode;
        this.sessionService.set(ViewProjectsMode, mode);
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/projects/projects.js